/* NIGHTMARKET theme script. No dependencies. */
(function () {
  'use strict';
  var NM = window.NM || { routes: {}, settings: {}, strings: {} };
  var root = document.documentElement;
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var reduce = function () { return root.getAttribute('data-motion') === 'off'; };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = NM.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    function f(n, d, t, dec) {
      var s = (n / 100).toFixed(d).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (s[1] ? dec + s[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
      return f(cents, 2, ',', '.');
    });
  }
  function announce(msg) { var a = $('[data-announce]'); if (!a) return; a.textContent = ''; setTimeout(function () { a.textContent = msg; }, 60); }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function titleHtml(t) { t = String(t || ''); var i = t.indexOf(' ['); return i > -1 ? '<span class="t-name">' + esc(t.slice(0, i)) + '</span><span class="t-color">' + esc(t.slice(i + 1)) + '</span>' : '<span class="t-name">' + esc(t) + '</span>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Day / Night ---------- */
  function setMode(mode) {
    var bg = $('#NMBackground');
    var apply = function () {
      root.setAttribute('data-mode', mode);
      try { localStorage.setItem('nm-mode', mode); } catch (e) {}
      document.dispatchEvent(new CustomEvent('nm:mode', { detail: mode }));
    };
    if (bg && !reduce()) {
      bg.classList.add('is-swapping');
      setTimeout(function () { apply(); requestAnimationFrame(function () { bg.classList.remove('is-swapping'); }); }, 260);
    } else apply();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mode-toggle]')) setMode(root.getAttribute('data-mode') === 'night' ? 'day' : 'night');
  });

  /* ---------- header shrink ---------- */
  var hdr = $('[data-header]');
  if (hdr) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { hdr.classList.toggle('is-compact', window.scrollY > 30); ticking = false; });
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- layers (menu, bag, search, quick view, size guide) ---------- */
  var lastFocus = null;
  function layer(name) { return $('[data-layer="' + name + '"]'); }
  function openLayer(name, trigger) {
    var el = layer(name); if (!el) return;
    $$('.layer.is-open').forEach(function (o) { if (o !== el) closeLayer(o, true); });
    lastFocus = trigger || (document.activeElement !== document.body ? document.activeElement : null) || $('[data-open="' + name + '"]');
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); root.classList.add('has-layer');
    $$('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.layer__panel', el);
    setTimeout(function () { var f = $('input[type="search"]', el) || panel; f && f.focus({ preventScroll: true }); }, 80);
  }
  function closeLayer(el, keepLock) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    $$('[data-open="' + el.getAttribute('data-layer') + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!keepLock) { root.classList.remove('has-layer'); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openLayer(o.getAttribute('data-open'), o); return; }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeLayer(c.closest('.layer')); }
  });
  document.addEventListener('keydown', function (e) {
    var open = $('.layer.is-open');
    if (!open) return;
    if (e.key === 'Escape') { closeLayer(open); return; }
    if (e.key !== 'Tab') return;
    var panel = $('.layer__panel', open);
    var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* menu accordion */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-acc]'); if (!b) return;
    var open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', open);
    var sub = b.nextElementSibling; if (sub) sub.classList.toggle('is-closed', !open);
  });

  /* ---------- announcement bar + drop countdown ---------- */
  function parseDrop(s) {
    if (!s) return null;
    var m = String(s).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
  }
  function tick(target, cb) {
    var run = function () {
      var ms = Math.max(0, target - Date.now());
      var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, mi = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
      cb(d, h, mi, s, ms);
      if (ms > 0) setTimeout(run, 1000);
    };
    run();
  }
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var ann = $('[data-ann]');
  if (ann) {
    var msgs = $$('.ann__msg:not([data-drop-msg])', ann);
    var drop = NM.settings && NM.settings.drop;
    var dropAt = drop && drop.enabled && drop.inBar ? parseDrop(drop.at) : null;
    if (dropAt && dropAt > Date.now()) {
      var dm = $('[data-drop-msg]', ann); dm.hidden = false; msgs.push(dm);
      tick(dropAt, function (d, h, mi, s, ms) { dm.textContent = ms > 0 ? (drop.label + ' ' + d + 'D ' + pad(h) + 'H ' + pad(mi) + 'M ' + pad(s) + 'S') : drop.label; });
    }
    if (msgs.length > 1) {
      var i = 0, secs = (+ann.getAttribute('data-rotate') || 5) * 1000, paused = false, hovering = false;
      var pauseBtn = $('[data-ann-pause]', ann);
      if (pauseBtn) {
        pauseBtn.hidden = false;
        pauseBtn.addEventListener('click', function () {
          paused = !paused; pauseBtn.setAttribute('aria-pressed', String(paused));
          pauseBtn.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
        });
      }
      ann.addEventListener('mouseenter', function () { hovering = true; });
      ann.addEventListener('mouseleave', function () { hovering = false; });
      ann.addEventListener('focusin', function () { hovering = true; });
      ann.addEventListener('focusout', function () { hovering = false; });
      if (reduce()) { paused = true; if (pauseBtn) { pauseBtn.setAttribute('aria-pressed', 'true'); pauseBtn.setAttribute('aria-label', 'Play announcements'); } }
      setInterval(function () {
        if (paused || hovering || document.hidden) return;
        msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on');
      }, secs);
    }
  }
  $$('[data-countdown]').forEach(function (el) {
    var at = parseDrop(el.getAttribute('data-countdown')); if (!at) return;
    tick(at, function (d, h, mi, s) {
      $('[data-d]', el).textContent = pad(d); $('[data-h]', el).textContent = pad(h);
      $('[data-m]', el).textContent = pad(mi); $('[data-s]', el).textContent = pad(s);
    });
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !reduce()) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('rise'); io.unobserve(en.target); } });
    }, { threshold: 0.08 });
    var watch = function (scope) { $$('[data-reveal]:not(.rise)', scope).forEach(function (el) { io.observe(el); }); };
    watch(document);
    NM.watchReveal = watch;
  } else { NM.watchReveal = function () {}; }

  /* ---------- bag ---------- */
  var cartState = null;
  try { cartState = JSON.parse(($('#CartJSON') || {}).textContent || 'null'); } catch (e) {}
  function bump() {
    $$('[data-cart-count]').forEach(function (n) {
      var p = n.parentElement; p.classList.remove('bump'); void p.offsetWidth; p.classList.add('bump');
    });
  }
  function renderCart(cart) {
    if (!cart) return;
    cartState = cart;
    $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    var lines = $('[data-cart-lines]');
    if (lines) {
      if (!cart.items.length) {
        lines.innerHTML = '<p class="cart__empty label muted">' + esc(NM.strings.empty || 'Your bag is empty.') + '</p>';
      } else {
        lines.innerHTML = cart.items.map(function (it, idx) {
          var img = sized(it.image, 160);
          var variant = it.product_has_only_default_variant ? '' : '<span class="muted">' + esc(it.variant_title) + '</span>';
          if (isGiftLine(it)) {
            return '<div class="line">' +
              '<a class="line__img shape" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
              '<div class="line__info"><span class="gift-tag">' + STAR_SVG + ' Free ' + esc((NM.gift && NM.gift.name) || 'gift') + '</span><a class="card__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
              '<span>' + (it.final_line_price === 0 ? 'Free' : money(it.final_line_price)) + '</span></div>' +
              '<button type="button" class="line__rm" data-gift-remove data-qty="' + (idx + 1) + '" data-to="0">Remove</button></div>';
          }
          return '<div class="line">' +
            '<a class="line__img shape" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="line__info"><a class="card__title" href="' + esc(it.url) + '">' + titleHtml(it.product_title) + '</a>' + variant +
            '<span>' + money(it.final_line_price) + '</span>' +
            '<span class="line__qty"><button type="button" data-qty="' + (idx + 1) + '" data-to="' + (it.quantity - 1) + '" aria-label="Remove one">−</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (idx + 1) + '" data-to="' + (it.quantity + 1) + '" aria-label="Add one">+</button></span></div>' +
            '<button type="button" class="line__rm" data-qty="' + (idx + 1) + '" data-to="0">Remove</button></div>';
        }).join('');
      }
    }
    renderProgress(cart);
    syncGift(cart);
    renderPromo(cart);
    var up = $('[data-upsell]');
    if (up) {
      var inCart = cart.items.map(function (i) { return String(i.product_id); });
      var shown = 0;
      $$('[data-upsell-item]', up).forEach(function (u) {
        var show = shown < 1 && inCart.indexOf(u.getAttribute('data-product-id')) === -1 && cart.items.length > 0;
        u.hidden = !show; if (show) shown++;
      });
      up.hidden = shown === 0;
    }
  }
  /* offer and free gift progress: one bar, a star marker per reward */
  var STAR_SVG = '<svg viewBox="0 0 100 100" aria-hidden="true"><path fill="currentColor" d="M50 5.3C52.47 45.87 58.34 47.54 97 50C58.34 52.46 52.47 54.13 50 94.7C47.53 54.13 41.66 52.46 3 50C41.66 47.54 47.53 45.87 50 5.3Z"/></svg>';
  function isGiftLine(it) { return it.properties && it.properties._nm_gift; }
  function paidTotal(cart) { return cart.items.reduce(function (t, it) { return t + (isGiftLine(it) ? 0 : it.final_line_price); }, 0); }
  function milestones() {
    var o = NM.offer || {}, g = NM.gift || {}, m = [];
    var sh = NM.ship || {};
    if (o.enabled && o.threshold > 0) m.push({ at: o.threshold, away: o.reward, done: o.unlocked });
    if (sh.enabled && sh.threshold > 0) m.push({ at: sh.threshold, away: 'free shipping', done: 'Free shipping' });
    if (g.enabled && g.threshold > 0) m.push({ at: g.threshold, away: 'a free ' + g.name, done: 'free ' + g.name });
    return m.sort(function (a, b) { return a.at - b.at; });
  }
  function renderProgress(cart) {
    var txt = $('[data-offer-text]'), bar = $('[data-offer-bar]'), track = $('[data-offer-track]');
    var m = milestones(); if (!txt || !bar || !m.length) return;
    var paid = paidTotal(cart), max = m[m.length - 1].at;
    var next = m.filter(function (x) { return x.at > paid; })[0];
    var hit = m.filter(function (x) { return x.at <= paid; });
    if (next) txt.textContent = paid > 0 ? money(next.at - paid) + ' ' + (NM.strings.away || 'away from') + ' ' + next.away : 'Spend ' + money(next.at) + ' for ' + next.away;
    else { var names = hit.map(function (x) { return x.done; }); txt.textContent = (names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0]) + ' unlocked'; txt.textContent = txt.textContent.charAt(0).toUpperCase() + txt.textContent.slice(1); }
    if (track && !track.getAttribute('data-marks')) {
      track.setAttribute('data-marks', '1');
      m.forEach(function (x) { var s = document.createElement('b'); s.className = 'bar__mark'; s.style.left = (x.at / max * 100) + '%'; s.setAttribute('data-at', x.at); s.innerHTML = STAR_SVG; track.appendChild(s); });
    }
    $$('.bar__mark', track).forEach(function (s) { s.classList.toggle('is-hit', +s.getAttribute('data-at') <= paid); });
    requestAnimationFrame(function () { bar.style.width = Math.min(100, paid / max * 100) + '%'; });
  }
  var giftBusy = false;
  var LOCK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>', CHECK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  function syncGift(cart) {
    var g = NM.gift || {}, card = $('[data-gift-card]');
    if (!g.enabled || !card) return;
    var paid = paidTotal(cart), idx = -1;
    cart.items.forEach(function (it, i) { if (isGiftLine(it)) idx = i; });
    var open = g.variants.filter(function (v) { return v.available; });
    var giftIds = g.variants.map(function (v) { return v.id; });
    var paidGift = cart.items.some(function (it) { return !isGiftLine(it) && giftIds.indexOf(it.variant_id) > -1; });
    var worth = (open[0] || g.variants[0] || {}).price || 0;
    var unlocked = paid >= g.threshold;
    // keep the bag honest: the gift leaves when the bag drops below the amount
    if (!giftBusy && !unlocked && idx > -1) { giftBusy = true; changeLine(idx + 1, 0).then(function () { giftBusy = false; }); return; }
    var declined = false; try { declined = sessionStorage.getItem('nm-gift-off') === '1'; } catch (e) {}
    if (!giftBusy && unlocked && idx === -1 && !paidGift && open.length === 1 && g.auto && !declined) { giftBusy = true; addGift(open[0].id).then(function () { giftBusy = false; }); return; }
    if (!cart.items.length || !open.length && idx === -1 && !paidGift) { card.hidden = true; return; }
    var state, body;
    if (idx > -1 || paidGift) {
      state = 'in';
      body = '<span class="gift-card__state">' + CHECK_SVG + ' In your bag, free at checkout</span><span class="gift-card__save">You save ' + money(worth) + '</span>';
    } else if (unlocked) {
      state = 'open';
      body = '<span class="gift-card__state">' + STAR_SVG + ' Unlocked</span>' +
        '<span class="gift-card__btns">' + open.map(function (v) {
          return '<button type="button" class="btn btn--solid btn--small" data-gift-variant="' + v.id + '">' + (open.length === 1 ? 'Add for ' + money(0) : esc(v.title)) + '</button>';
        }).join('') + '</span><span class="gift-card__save">' + (open.length > 1 ? 'Pick a size, it\'s ' + money(0) + '. ' : '') + 'You save ' + money(worth) + '</span>';
    } else {
      state = 'locked';
      body = '<span class="gift-card__state">' + LOCK_SVG + ' Spend ' + money(g.threshold - paid) + ' more to unlock</span>' +
        '<span class="bar gift-card__bar"><i style="width:' + Math.min(100, paid / g.threshold * 100) + '%"></i></span>';
    }
    card.className = 'gift-card is-' + state;
    card.innerHTML = (g.image ? '<img src="' + esc(g.image) + '" alt="">' : '<span class="gift-card__ph"></span>') +
      '<div class="gift-card__t"><span class="gift-card__eyebrow">Free gift at ' + money(g.threshold) + '</span>' +
      '<span class="card__title">' + titleHtml(g.title) + '</span>' + body + '</div>';
    card.hidden = false;
  }
  function renderPromo(cart) {
    var p = NM.promo || {}, el = $('[data-promo-nudge]');
    if (!el) return;
    if (!p.enabled) { el.hidden = true; return; }
    var set = (p.buy || 2) + (p.get || 1);
    var qty = cart.items.reduce(function (t, it) { return t + (p.ids.indexOf(it.product_id) > -1 ? it.quantity : 0); }, 0);
    var r = qty % set;
    if (qty > 0 && r >= p.buy) {
      el.innerHTML = STAR_SVG + '<span>Add one more <a href="' + esc(p.url) + '">' + esc(p.name) + '</a>, it\'s free</span>';
      el.hidden = false;
    } else if (qty >= set) {
      var free = Math.floor(qty / set) * p.get;
      el.innerHTML = STAR_SVG + '<span>' + free + ' free ' + esc(p.name) + (free > 1 ? 's' : '') + ' at checkout</span>';
      el.hidden = false;
    } else el.hidden = true;
  }
  function addGift(id) {
    var fd = new FormData(); fd.append('id', id); fd.append('quantity', 1); fd.append('properties[_nm_gift]', '1');
    return fetch(NM.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd }).then(fetchCart).then(renderCart).catch(function () {});
  }
  function changeLine(line, qty) {
    return fetch(NM.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-gift-remove]');
    if (r) { try { sessionStorage.setItem('nm-gift-off', '1'); } catch (err) {} }
    var b = e.target.closest('[data-gift-variant]'); if (!b) return;
    try { sessionStorage.removeItem('nm-gift-off'); } catch (err) {}
    giftBusy = true; addGift(b.getAttribute('data-gift-variant')).then(function () { giftBusy = false; });
  });
  function fetchCart() { return fetch(NM.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addToCart(body, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(NM.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(fetchCart)
      .then(function (cart) { renderCart(cart); bump(); openLayer('cart'); announce('Added to bag. ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in your bag.'); })
      .catch(function (err) { alertInline(btn, (err && (err.description || err.message)) || 'Could not add to bag'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  function alertInline(btn, msg) {
    if (!btn) return;
    var p = document.createElement('p'); p.className = 'form-error'; p.textContent = msg; p.setAttribute('role', 'alert');
    btn.insertAdjacentElement('afterend', p); setTimeout(function () { p.remove(); }, 4000);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add-variant]');
    if (a) {
      e.preventDefault();
      var fd = new FormData(); fd.append('id', a.getAttribute('data-add-variant')); fd.append('quantity', 1);
      rememberSize(a.textContent.trim());
      addToCart(fd, a);
      return;
    }
    var q = e.target.closest('[data-qty]');
    if (q) {
      fetch(NM.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +q.getAttribute('data-qty'), quantity: Math.max(0, +q.getAttribute('data-to')) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  renderCart(cartState);
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart().then(renderCart); });

  /* ---------- size memory ---------- */
  function isSizeName(n) { return /size|waist|taille|talla/i.test(n || ''); }
  function rememberSize(v) { if (NM.settings.sizeMemory && v) store.set('nm-size', v); }
  function savedSize() { return NM.settings.sizeMemory ? store.get('nm-size') : null; }

  /* ---------- product page ---------- */
  $$('[data-product]').forEach(function (sec) {
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', sec).textContent); } catch (e) {}
    var picker = $('[data-picker]', sec);
    var input = $('[data-variant-input]', sec);
    var addBtn = $('[data-add-button]', sec), addLabel = $('[data-add-label]', sec);
    var low = $('[data-low-stock]', sec), notify = $('[data-notify]', sec), dyn = $('[data-dynamic]', sec);
    var sticky = $('[data-sticky-buy]', sec), stickyAdd = $('[data-sticky-add]', sec), stickyPrice = $('[data-sticky-price]', sec);
    var groups = picker ? $$('.picker__group', picker) : [];

    function selected() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
    function find(opts) { return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; }
    function markAvailability(opts) {
      groups.forEach(function (g, gi) {
        $$('.pick', g).forEach(function (lab) {
          var val = $('input', lab).value;
          var trial = opts.slice(); trial[gi] = val;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return i === gi ? o === val : (groups.length === 1 || o === trial[i]); }); });
          lab.classList.toggle('is-out', !ok);
        });
      });
    }
    function update(v, opts) {
      if (!v) { if (addBtn) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; } return; }
      if (input) input.value = v.id;
      var priceEl = $('[data-product-price] [data-price]', sec);
      if (priceEl) priceEl.innerHTML = '<span class="price__now">' + money(v.price) + '</span>' + (v.compare > v.price ? '<s class="price__was">' + money(v.compare) + '</s>' : '');
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? (NM.strings.addToBag || 'Add to bag') : (NM.strings.soldOut || 'Sold out'); }
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (dyn) dyn.hidden = !v.available;
      if (notify) {
        notify.hidden = v.available;
        var tags = $('[data-notify-tags]', notify);
        if (tags) tags.value = tags.getAttribute('data-base') + ',' + 'restock-' + sec.getAttribute('data-handle') + '-' + v.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      }
      if (low) {
        if (v.low > 0 && v.available) { low.textContent = (NM.strings.onlyLeft || 'Only [count] left').replace('[count]', v.low); low.hidden = false; }
        else low.hidden = true;
      }
      groups.forEach(function (g, i) { var s = $('[data-option-value]', g); if (s) s.textContent = opts[i] || ''; });
      announce((opts.filter(Boolean).join(' ') + ', ' + money(v.price) + (v.available ? '' : ', sold out') + (v.low > 0 && v.available ? ', only ' + v.low + ' left' : '')).trim());
      if (v.media) {
        var m = $('[data-media-id="' + v.media + '"]', sec);
        if (m && window.innerWidth < 750) { var gal = $('[data-gallery]', sec); gal.scrollTo({ left: m.offsetLeft, behavior: reduce() ? 'auto' : 'smooth' }); }
      }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    }
    if (picker) {
      picker.addEventListener('change', function (e) {
        var g = e.target.closest('.picker__group');
        if (g && isSizeName(g.getAttribute('data-option-name'))) rememberSize(e.target.value);
        var opts = selected(); markAvailability(opts); update(find(opts), opts);
      });
      // size memory: preselect the shopper's usual size when the link didn't ask for a variant
      var mem = savedSize();
      if (mem && !/[?&]variant=/.test(location.search)) {
        groups.forEach(function (g, gi) {
          if (!isSizeName(g.getAttribute('data-option-name'))) return;
          var match = $$('input', g).filter(function (i) { return i.value === mem; })[0];
          if (match) {
            var opts = selected(); opts[gi] = mem;
            var v = find(opts);
            if (v && v.available) { match.checked = true; markAvailability(opts); update(v, opts); }
          }
        });
      }
      markAvailability(selected());
    }

    // add to bag without leaving the page
    var form = $('[data-product-form]', sec);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(new FormData(form), addBtn); });
    if (stickyAdd && form) stickyAdd.addEventListener('click', function () { addToCart(new FormData(form), stickyAdd); });
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) {
        var on = !en.isIntersecting && en.boundingClientRect.top < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on));
      }); }).observe(addBtn);
    }

    // gallery counter on phones
    var gal = $('[data-gallery]', sec), count = $('[data-gallery-count]', sec);
    if (gal && count) {
      gal.addEventListener('scroll', function () {
        var i = Math.round(gal.scrollLeft / gal.clientWidth) + 1; count.textContent = i + ' / ' + gal.children.length;
      }, { passive: true });
    }

    // recently viewed
    var h = sec.getAttribute('data-handle');
    var list = (store.get('nm-recent') || []).filter(function (x) { return x !== h; });
    list.unshift(h); store.set('nm-recent', list.slice(0, 16));
  });

  /* share */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-share]'); if (!b) return;
    var data = { title: b.getAttribute('data-share-title') || document.title, url: location.href.split('?')[0] };
    if (navigator.share) { navigator.share(data).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () {
      var s = $('span', b); var old = s.textContent; s.textContent = NM.strings.copied || 'Link copied';
      setTimeout(function () { s.textContent = old; }, 1600);
    });
  });

  /* ---------- Jump back in ---------- */
  $$('[data-recent]').forEach(function (sec) {
    var limit = +sec.getAttribute('data-limit') || 8;
    var exclude = sec.getAttribute('data-exclude');
    var handles = (store.get('nm-recent') || []).filter(function (x) { return x && x !== exclude; }).slice(0, limit);
    var rail = $('[data-recent-rail]', sec);
    if (!handles.length) { if (!rail.children.length) sec.hidden = true; return; }
    Promise.all(handles.map(function (hd) {
      return fetch(NM.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(hd) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(Boolean); if (!ps.length) return;
      rail.innerHTML = ps.map(function (p) {
        var img = sized(p.featured_image, 480);
        var quick = '';
        if (p.available !== false) {
          var single = p.options && p.options.length === 1 && p.variants.length <= 10 && !(p.variants.length === 1 && p.variants[0].title === 'Default Title');
          if (single) quick += '<div class="card__sizes" role="group" aria-label="Quick add ' + esc(p.title) + '">' + p.variants.map(function (v) {
            return '<button type="button" class="card__size" data-add-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.option1) + '</button>';
          }).join('') + '</div>';
          quick += '<button type="button" class="card__plus" data-quick-view="' + esc(p.handle) + '" aria-label="Choose a size for ' + esc(p.title) + '">+</button>';
        }
        return '<div class="tile shape"><a class="tile__link" href="' + esc(p.url) + '" data-instant aria-label="' + esc(p.title) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<span class="tile__tag">' + money(p.price) + '</span>' + quick + '</div>';
      }).join('');
      var note = $('[data-recent-note]', sec); if (note) note.textContent = 'Recently viewed';
    });
  });

  /* ---------- Quick view ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-view]'); if (!b) return;
    e.preventDefault();
    var body = $('[data-qv-body]'); if (!body) { location.href = NM.routes.root.replace(/\/$/, '') + '/products/' + b.getAttribute('data-quick-view'); return; }
    body.innerHTML = '<p class="label muted">Loading…</p>';
    openLayer('quick');
    fetch(NM.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(b.getAttribute('data-quick-view')) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { renderQuickView(body, p); });
  });
  function renderQuickView(body, p) {
    var mode = NM.settings.sizeChart, pics = (p.images || []).slice();
    var imgMedia = (p.media || []).filter(function (m) { return m.media_type === 'image' && m.src; });
    if (imgMedia.length > 1 && mode === 'alt') {
      pics = imgMedia.filter(function (m) { return !/^size chart/i.test(m.alt || ''); }).map(function (m) { return m.src; });
    } else if (mode === 'last' && pics.length > 1) pics.pop();
    var imgs = pics.slice(0, 5).map(function (src) {
      return '<img src="' + esc(sized(src, 900)) + '" alt="' + esc(p.title) + '" loading="lazy">';
    }).join('');
    var opts = p.options || [];
    var mem = savedSize();
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    if (mem) {
      var mv = p.variants.filter(function (v) { return v.available && v.options.indexOf(mem) > -1; })[0];
      if (mv) first = mv;
    }
    var groups = (opts.length === 1 && opts[0].name === 'Title') ? '' : opts.map(function (o, gi) {
      return '<fieldset class="picker__group" data-gi="' + gi + '" data-name="' + esc(o.name) + '"><legend class="label">' + esc(o.name) + '</legend><div class="picker__values">' +
        o.values.map(function (val) {
          var ok = p.variants.some(function (v) { return v.available && v.options[gi] === val; });
          return '<label class="pick' + (ok ? '' : ' is-out') + '"><input type="radio" name="qv-' + gi + '" value="' + esc(val) + '"' + (first.options[gi] === val ? ' checked' : '') + '><span>' + esc(val) + '</span></label>';
        }).join('') + '</div></fieldset>';
    }).join('');
    body.innerHTML = '<div class="qv__media shape-soft">' + imgs + '</div><div class="qv__info">' +
      '<a class="qv__title label card__title" href="' + esc(p.url) + '">' + titleHtml(p.title) + '</a>' +
      '<span class="price" data-qv-price>' + money(first.price) + '</span>' + groups +
      '<button type="button" class="btn btn--solid btn--block" data-qv-add>' + (first.available ? 'Add to bag' : 'Sold out') + '</button>' +
      '<a class="label muted" href="' + esc(p.url) + '">View full details</a></div>';
    var current = first;
    var btn = $('[data-qv-add]', body);
    btn.disabled = !first.available;
    body.onchange = function (e) {
      var sel = $$('fieldset', body).map(function (f) { var c = $('input:checked', f); return c && c.value; });
      var v = p.variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      var g = e.target.closest('fieldset'); if (g && isSizeName(g.getAttribute('data-name'))) rememberSize(e.target.value);
      current = v;
      btn.disabled = !(v && v.available); btn.textContent = v && v.available ? 'Add to bag' : 'Sold out';
      if (v) $('[data-qv-price]', body).textContent = money(v.price);
    };
    btn.addEventListener('click', function () {
      if (!current || !current.available) return;
      var fd = new FormData(); fd.append('id', current.id); fd.append('quantity', 1);
      addToCart(fd, btn);
    });
  }

  /* ---------- recommendations ---------- */
  $$('[data-recommendations]').forEach(function (sec) {
    var url = sec.getAttribute('data-url'); if (!url || sec.children.length) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = $('[data-recommendations]', tmp);
        if (inner && inner.innerHTML.trim()) { sec.innerHTML = inner.innerHTML; NM.watchReveal(sec); }
      });
    };
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { o.disconnect(); load(); } }, { rootMargin: '400px' }); o.observe(sec);
    } else load();
  });

  /* ---------- collection filters + Show more ---------- */
  $$('[data-filters]').forEach(function (form) {
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      location.href = form.getAttribute('action') + '?' + params.toString();
    });
    document.addEventListener('click', function (e) {
      $$('details.filter[open]', form).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  });
  var loadingMore = false;
  function loadMore(more) {
    if (loadingMore || !more || !more.isConnected) return;
    var grid = more.closest('section') ? $('[data-grid]', more.closest('section')) : $('[data-grid]');
    if (!grid) { location.href = more.href; return; }
    loadingMore = true; more.textContent = 'Loading…'; more.setAttribute('aria-busy', 'true');
    fetch(more.href).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var next = $('[data-grid]', tmp); var nextMore = $('[data-show-more]', tmp);
      var known = {}; $$('a.card__info', grid).forEach(function (a) { known[a.getAttribute('href')] = 1; });
      if (next) {
        Array.prototype.slice.call(next.children).forEach(function (c) {
          var a = c.querySelector && c.querySelector('a.card__info');
          if (a && known[a.getAttribute('href')]) return;
          grid.appendChild(c);
        });
        NM.watchReveal(grid);
      }
      if (nextMore) { more.href = nextMore.href; more.textContent = 'Show more'; more.removeAttribute('aria-busy'); } else more.parentElement.remove();
    }).catch(function () { more.textContent = 'Show more'; }).finally(function () { loadingMore = false; });
  }
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-show-more]'); if (!more) return;
    e.preventDefault(); loadMore(more);
  });
  var keyboardUser = false;
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') keyboardUser = true; });
  if (NM.settings.infinite && 'IntersectionObserver' in window) {
    var moreObs = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting && !keyboardUser) loadMore(en.target); });
    }, { rootMargin: '900px 0px' });
    $$('[data-show-more]').forEach(function (m) { moreObs.observe(m); });
    // keep loading if the new rows still don't fill the screen
    setInterval(function () { if (keyboardUser) return; $$('[data-show-more]').forEach(function (m) { var r = m.getBoundingClientRect(); if (r.top < window.innerHeight + 900) loadMore(m); }); }, 1200);
  }

  /* ---------- predictive search ---------- */
  var ps = $('[data-predictive]');
  if (ps && NM.settings.predictive) {
    var out = $('[data-predictive-results]'), timer;
    ps.addEventListener('input', function () {
      clearTimeout(timer);
      var q = ps.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(NM.routes.search + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) { var tmp = document.createElement('div'); tmp.innerHTML = html; var r = $('.ps', tmp); out.innerHTML = r ? r.outerHTML : ''; });
      }, 220);
    });
  }

  /* ---------- instant pages ---------- */
  if (NM.settings.instantPages && !(navigator.connection && navigator.connection.saveData)) {
    var done = {};
    var prefetch = function (e) {
      var a = e.target.closest && e.target.closest('a[data-instant]');
      if (!a || done[a.href] || a.origin !== location.origin) return;
      done[a.href] = true;
      var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
    };
    document.addEventListener('pointerover', prefetch, { passive: true });
    document.addEventListener('touchstart', prefetch, { passive: true });
  }

  /* ---------- cookie banner (Shopify Customer Privacy API) ---------- */
  function withPrivacy(cb) {
    if (window.Shopify && Shopify.customerPrivacy) return cb(Shopify.customerPrivacy);
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (err) {
        if (!err && Shopify.customerPrivacy) cb(Shopify.customerPrivacy);
      });
    }
  }
  var consentEl = $('[data-consent]');
  withPrivacy(function (cp) {
    // US privacy: confirm a Global Privacy Control signal where data sale opt-outs apply
    var gpc = $('[data-gpc-notice]');
    try { if (gpc && navigator.globalPrivacyControl === true && (!cp.saleOfDataRegion || cp.saleOfDataRegion())) gpc.hidden = false; } catch (e) {}
    if (!consentEl) return;
    var undecided = false;
    try {
      var c = cp.currentVisitorConsent() || {};
      undecided = [c.analytics, c.marketing, c.preferences].some(function (v) { return v === '' || v == null; });
    } catch (e) { undecided = true; }
    var otherBanner = document.getElementById('shopify-pc__banner');
    if (!cp.shouldShowBanner() || !undecided || otherBanner) return;
    consentEl.hidden = false; root.classList.add('has-consent');
    requestAnimationFrame(function () { root.style.setProperty('--consent-h', (consentEl.offsetHeight + 10) + 'px'); });
    function finish(choice) {
      cp.setTrackingConsent(choice, function () {});
      consentEl.classList.add('is-leaving');
      setTimeout(function () { consentEl.hidden = true; root.classList.remove('has-consent'); }, 360);
    }
    $('[data-consent-accept]', consentEl).addEventListener('click', function () { finish({ analytics: true, marketing: true, preferences: true, sale_of_data: true }); });
    $('[data-consent-decline]', consentEl).addEventListener('click', function () { finish({ analytics: false, marketing: false, preferences: false, sale_of_data: false }); });
    var more = $('[data-consent-more]', consentEl), save = $('[data-consent-save]', consentEl), choose = $('[data-consent-choose]', consentEl);
    more.addEventListener('click', function () {
      choose.hidden = false; save.hidden = false; more.hidden = true; more.setAttribute('aria-expanded', 'true');
      root.style.setProperty('--consent-h', (consentEl.offsetHeight + 10) + 'px');
    });
    save.addEventListener('click', function () {
      var a = $('[data-consent-analytics]', consentEl).checked, m = $('[data-consent-marketing]', consentEl).checked;
      finish({ analytics: a, marketing: m, preferences: a, sale_of_data: m });
    });
  });

  /* ---------- lantern light ---------- */
  var lantern = $('.lantern');
  if (lantern && window.matchMedia('(pointer: fine)').matches && !reduce()) {
    var raf = 0, x = 0, y = 0;
    window.addEventListener('pointermove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!raf) raf = requestAnimationFrame(function () { lantern.style.setProperty('--lx', x + 'px'); lantern.style.setProperty('--ly', y + 'px'); raf = 0; });
      lantern.classList.add('is-on');
    }, { passive: true });
    document.addEventListener('pointerleave', function () { lantern.classList.remove('is-on'); });
  }
})();
